import { UserModel } from "./UserModel";

/**
 * * Модель файла
 */
export class TaskFileModel {
  /**ID файла */
  Id!: number;
  /**Ссылка на файл */
  Url!: string;
  /**Ссылка на превью видео */
  VideoPreviewUrl?: string;
  /**Название файла */
  Name!: string;
  /**Размер файла (в байтах) */
  Size!: number;
  /**Дата загрузки */
  DateUpload!: Date;
  /**Пользователь загрузивший файл */
  User!: UserModel;
  /**ID загрузки */
  UploadId?: string;
  /**Прогресс загрузки файла */
  UploadProgress?: number;
  /**В обработке */
  IsProccessing?: boolean;
  /**Отправка последнего чанка файла */
  IsSendingLastChunk?: boolean;

  constructor(obj?: Partial<TaskFileModel>) {
    Object.assign(this, obj);
  }
}
